/* 2026-09-30: controls for the family film on the item page.
   The native chrome carried a Chrome-grey bar, a kebab menu with a download item, and looked nothing like
   the card around it. Progressive enhancement: if this file never loads the <video> still plays, because the
   markup keeps a real play button. It also gives the inline film the play and finish tracking that the
   lightbox already had and this surface did not.
   Lives in an asset rather than inline: sections/pdp-marketplace.liquid is within 2 KB of Shopify's
   262,144-byte section limit. */
(function () {
  var w = document.querySelector('[data-vwrap]');
  if (!w) return;
  var v = w.querySelector('video');
  if (!v) return;

  var big  = w.querySelector('[data-vbig]'),
      play = w.querySelector('[data-vplay]'),
      seek = w.querySelector('[data-vseek]'),
      cur  = w.querySelector('[data-vtime]'),
      tot  = w.querySelector('[data-vtotal]'),
      mute = w.querySelector('[data-vmute]'),
      full = w.querySelector('[data-vfull]');

  var T = { product: w.dataset.vp || '', family: w.dataset.vf || '', section: 'pdp-b', video: w.dataset.vu || '' };
  var sent = false;
  function track(n) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, T); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', n, T); } catch (e) {}
  }
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }

  var ICON_PLAY  = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.6v12.8L19 12z"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5h3.4v14H7zM13.6 5H17v14h-3.4z"/></svg>';

  function toggle() {
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    else v.pause();
  }
  if (big) big.addEventListener('click', toggle);
  if (play) play.addEventListener('click', toggle);
  v.addEventListener('click', toggle);

  v.addEventListener('play', function () {
    w.classList.add('on');
    if (play) { play.innerHTML = ICON_PAUSE; play.setAttribute('aria-label', 'Pause'); }
    if (!sent) { sent = true; track('ai_trax_video_play'); }
  });
  v.addEventListener('pause', function () {
    if (play) { play.innerHTML = ICON_PLAY; play.setAttribute('aria-label', 'Play'); }
  });
  v.addEventListener('ended', function () {
    w.classList.remove('on');
    if (play) { play.innerHTML = ICON_PLAY; play.setAttribute('aria-label', 'Play'); }
    track('ai_trax_video_end');
  });
  v.addEventListener('loadedmetadata', function () { if (tot) tot.textContent = fmt(v.duration); });
  v.addEventListener('timeupdate', function () {
    if (cur) cur.textContent = fmt(v.currentTime);
    if (seek && v.duration && !seek.matches(':active')) seek.value = String(Math.round(v.currentTime / v.duration * 1000));
  });
  if (seek) seek.addEventListener('input', function () { if (v.duration) v.currentTime = seek.value / 1000 * v.duration; });
  if (mute) mute.addEventListener('click', function () {
    v.muted = !v.muted;
    w.classList.toggle('muted', v.muted);
    mute.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
  });
  if (full) full.addEventListener('click', function () {
    if (document.fullscreenElement) { if (document.exitFullscreen) document.exitFullscreen(); return; }
    if (w.requestFullscreen) w.requestFullscreen();
    else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
  });
})();
